import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import { AuthService } from './security/auth.service';
import { Router } from '@angular/router';
import {LocalStorageService} from "./services/local-storage.service";
import {Location} from "@angular/common";
import {PATH_BEFORE_REFRESH, RoleID, SUBMISSION_PATH} from "./common/Constants";
import {UserService} from "./services/user.service";
import {TitleService} from "./services/title.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  isAuthenticated: boolean;
  private authSubscription: Subscription;

  @HostListener('window:beforeunload', ['$event'])
  doSomething($event) {
    if(this.location.path() != '/login')
      this.localStorageService.set(PATH_BEFORE_REFRESH, this.location.path())
  }

  constructor(
    private router: Router,
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private location: Location,
    private userService: UserService,
    private titleService: TitleService
  ) {
    this.isAuthenticated = false;
  }

  ngOnInit(): void {
    // Subscribe to authentication state changes
    this.authSubscription = this.authService.authenticationSubject.subscribe(isAuthenticated => {
      this.isAuthenticated = isAuthenticated;
      this.titleService.setTitle(isAuthenticated);
    });

    // Initial authentication check
    this.authService.isAuthenticated().then((success: boolean) => {
      this.isAuthenticated = success;
      this.titleService.setTitle(success);
    }).catch((error) => {
      this.isAuthenticated = false;
      this.titleService.setTitle(false);
    });
  }

  ngOnDestroy(): void {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }
}
